import moment from "moment";
import React, { useEffect, useState } from "react";
import { Card, CardBody } from "reactstrap";
import CustomDatePicker from "views/pages/manage/common/commonComponents/CustomDatePicker";
import CustomDatePickerV2 from "views/pages/manage/common/commonComponents/CustomDatePicker-V2";
import AAutoComplete from "views/pages/manage/common/form-fields-mui/AAutoComplete";
import { labelSyle } from "../../collectPayment/selectPaymentMode/components/constant";
import AInput from "views/pages/manage/common/formFeilds/customInput/AInput";
import {
  initialForm,
  initialInputFilter,
  isFilterApplied,
  labelStyles,
} from "./constant";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import { initialFilterForm } from "views/pages/manage/edpOps/stockManagement/mastersAndMapping/onBoardingMaterialIdSetup/constant";

const FilterForm = ({
  dropdowns = {},
  closeForm,
  globalFilter,
  setGlobalFilter,
  setShowOnlyPendingRequests,
  searchHandler,
  filterCount,
  setFilterCount,
}) => {
  const [filterForm, setFilterForm] = useState({});
  const filterFormHandler = (key, value) => {
    setFilterForm((prev) => ({ ...prev, [key]: value }));
  };
  const status = globalFilter?.pendingOnly ? { staus: [] } :(globalFilter?.status?{}:{status:[]});
  useEffect(
    () =>{
      setFilterForm({
        ...globalFilter,
        ...status,
        ...initialInputFilter,
        pendingOnly: false,
      })},
    []
  );
  const handleApplyFilter = () => {
    const filterCount = isFilterApplied(filterForm);
    console.log("filter", filterCount);
    setFilterCount(filterCount);
    searchHandler(0, {
      ...globalFilter,
      ...status,
      ...initialForm,
      ...filterForm,
      pendingOnly: false,
    });
    setGlobalFilter((prev) => ({
      ...prev,
      ...status,
      ...initialForm,
      ...filterForm,
      pendingOnly: false,
    }));
    setShowOnlyPendingRequests(false);
    closeForm();
  };
  const removeFilterHandler = () => {
    searchHandler(0, { ...globalFilter, ...initialForm });
    setGlobalFilter((prev) => ({ ...prev, ...initialForm }));
    setFilterCount(0);
    closeForm();
  };
  const checkFilter = () => {
    return (
      isFilterApplied({
        ...filterForm,
      }) == 0
    );
  };

  return (
    <Card
      className="mb-0 regular-body label-color"
      style={{ width: "330px", borderRadius: "12px" }}
    >
      <CardBody className="d-flex flex-column">
        <div className="text-bold text-lg mb-2">Filters</div>

        <div className="d-flex flex-column gap-md">
          <div style={labelStyles}>Employee Id</div>
          <AInput
            type="text"
            value={filterForm?.employeeId}
            handler={(value) => {
              filterFormHandler("employeeId", value);
            }}
            placeholder="Enter"
          />
          <div style={labelStyles}>EMPR No.</div>
          <AInput
            type="text"
            value={filterForm?.epmrNumber}
            handler={(value) => {
              filterFormHandler("epmrNumber", value);
            }}
            placeholder="Enter"
          />
          <div style={labelStyles}>Course Id</div>
          <AInput
            type="text"
            value={filterForm?.courseId}
            handler={(value) => {
              filterFormHandler("courseId", value);
            }}
            placeholder="Enter"
          />
          <AAutoComplete
            label="Payment Mode"
            placeholder="Select to add"
            items={dropdowns?.paymode}
            currentValue={filterForm?.paymentMode}
            isShowCount={true}
            handleChange={(value) => {
              filterFormHandler("paymentMode", value);
            }}
            inputKey=""
          />
          <AAutoComplete
            label="Business Area"
            placeholder="Select to add"
            items={dropdowns?.bu}
            currentValue={filterForm?.businessAreaId}
            isShowCount={true}
            handleChange={(value) => {
              filterFormHandler("businessAreaId", value);
            }}
            inputKey=""
          />
          <AAutoComplete
            label="Status"
            placeholder="Select to add"
            items={dropdowns?.status}
            currentValue={filterForm?.status}
            isShowCount={true}
            handleChange={(value) => {
              filterFormHandler("status", value);
            }}
            inputKey=""
          />
          <div style={labelStyles}>Receipting Date</div>
          <div className={"d-flex flex justify-content-between"}>
            <CustomDatePickerV2
              placeHolder="From"
              maxDate={moment(new Date())}
              value={filterForm?.receiptDateFrom}
              width={"18px"}
              handler={(index, date, keyName) => {
                filterFormHandler("receiptDateFrom", date);
              }}
            />
            {console.log('receipted',filterForm?.receiptingDateTo)}
            <CustomDatePickerV2
              placeHolder="To"
              width={"18px"}
              maxDate={moment(new Date())}
              minDate={filterForm?.receiptDateFrom}
              value={filterForm?.receiptDateTo}
              handler={(index, date, keyName) => {
                filterFormHandler("receiptDateTo", date);
              }}
              disabled={!filterForm?.receiptDateFrom}
            />
          </div>

          <div
            className={"mt-3 d-flex flex-row-reverse justify-content-between"}
          >
            <AButton
              variant="primary_filled"
              className="w-full"
              onClick={() => {
                handleApplyFilter();
              }}
              disabled={checkFilter()}
              updatedStyle={filterCount > 0 ? "" : { width: "100%" }}
            >
              Apply filter
            </AButton>

            {filterCount > 0 && (
              <AButton
                variant="outline"
                className="button_remove_left_margin"
                updatedStyle={{ border: "1px solid #CC5F5F", color: "#CC5F5F" }}
                onClick={() => {
                  removeFilterHandler();
                }}
              >
                Remove filter
              </AButton>
            )}
          </div>
        </div>
      </CardBody>
    </Card>
  );
};
export default FilterForm;
